<div class="flex align-items-center justify-content-center mb-8">
    <div style=" width: 220px">
        <img width="100%" alt="Logo" src="assets/images/Logo_High_Res.jpg" />
    </div>
</div>

<h1>
    {{deal?.customer?.name}} - <span>{{ 'preview.title' | translate }}</span>
</h1>

<div class="flex flex-column gap-2">
    <p-table [value]="deal?.lines ?? []" styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
            <tr>
                <th>{{ 'payment.columns.product' | translate }}</th>
                <th>{{ 'payment.columns.price' | translate }}</th>
                <th>{{ 'payment.columns.quantity' | translate }}</th>
                <th>{{ 'payment.columns.discount' | translate }}</th>
                <th>{{ 'payment.columns.tax' | translate }}</th>
                <th>{{ 'payment.columns.amount' | translate }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td>{{ product.productName }}</td>
                <td>{{ product.itemPrice | currency : 'EUR' : '' : '1.2-2' }}</td>
                <td>{{ product.quantity | currency : 'EUR' : '' : '1.2-2' }}</td>
                <td>
                    {{ product.discount | currency : 'EUR' : '' : '1.2-2' }} <span
                        *ngIf="product.discountPercentage > 0">
                        ({{
                        product.discountPercentage
                        }}%)
                    </span>
                </td>
                <td>{{ product.vat | currency : 'EUR' : '' : '1.2-2' }}</td>
                <td>{{ product.netPrice | currency : 'EUR' : '' : '1.2-2' }}</td>
            </tr>
        </ng-template>

        <ng-template pTemplate="footer" let-product>
            <tr>
                <td colspan="4">
                    <div class="flex flex-column">
                        <span>{{ 'payment.vatType' | translate }}: {{ deal?.customer?.taxPolicy! | fpa }}</span>
                    </div>
                </td>
                <td colspan="2">
                    <div class="flex flex-column text-right">
                        <span>
                            {{ 'payment.netAmount' | translate }}: {{
                            deal?.netValue| currency : 'EUR' : 'symbol'
                            : '1.2-2'
                            }}
                        </span>
                        <span>
                            {{ 'payment.grossAmount' | translate }}: {{
                            deal?.value| currency : 'EUR' : 'symbol' :
                            '1.2-2'
                            }}
                        </span>
                    </div>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>